
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/palaute",
      function () {
        return require("private-next-pages/palaute.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/palaute"])
      });
    }
  